/* New Glory: custom RSVP event on the Google & YouTube app's existing tag.
 * Does not load/configure a Google tag, send pageviews, or override session IDs.
 */
(function () {
  'use strict';
  if (typeof window.ngTrackRsvp === 'function') return;
  var measurementId = 'G-KXEYRX9FKN';
  var fields = {
    event_slug: 100, event_title: 150, event_date_iso: 32,
    selected_distance: 50, location_city: 100, page_path: 200,
    rsvp_surface: 50
  };
  var privacyLoading = false;
  function loadPrivacyApi() {
    var shopify = window.Shopify;
    if (!shopify || shopify.customerPrivacy || privacyLoading || typeof shopify.loadFeatures !== 'function') return;
    privacyLoading = true;
    shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function () {
      privacyLoading = false;
    });
  }
  loadPrivacyApi();

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return Boolean(privacy && typeof privacy.analyticsProcessingAllowed === 'function'
      && privacy.analyticsProcessingAllowed());
  }

  function appTagConfigured() {
    return Array.isArray(window.dataLayer) && window.dataLayer.some(function (command) {
      if (!command) return false;
      // The app may configure a GT- tag ID with this GA4 destination.
      // Confirm it has actually sent a native pageview to this stream.
      if (command[0] !== 'event' || command[1] !== 'page_view' || !command[2]) return false;
      var destinations = command[2].send_to;
      return Array.isArray(destinations)
        ? destinations.indexOf(measurementId) !== -1
        : destinations === measurementId;
    });
  }

  function pageLocation(raw) {
    var url = new URL(raw, window.location.origin);
    var clean = new URL(url.origin + url.pathname);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'utm_id', 'utm_source_platform', 'gclid', 'dclid', 'gbraid', 'wbraid'].forEach(function (name) {
      var value = url.searchParams.get(name);
      if (value) clean.searchParams.set(name, value);
    });
    return clean.href;
  }

  window.ngTrackRsvp = function (data) {
    loadPrivacyApi();
    var emitted = false;
    var deadline = Date.now() + 10000;
    var params = {send_to: measurementId, page_location: pageLocation(window.location.href)};
    Object.keys(fields).forEach(function (name) {
      params[name] = typeof data[name] === 'string' ? data[name].slice(0, fields[name]) : '';
    });
    params.page_title = document.title.slice(0, 150);
    // Keep the native tag's referrer/session handling. No manually created IDs.
    function attempt() {
      if (emitted || Date.now() >= deadline) return;
      if (!window.Shopify || !window.Shopify.customerPrivacy) {
        loadPrivacyApi();
        window.setTimeout(attempt, 250);
        return;
      }
      if (!analyticsAllowed()) return;
      if (typeof window.gtag !== 'function' || !appTagConfigured()) {
        window.setTimeout(attempt, 250);
        return;
      }
      var settled = false;
      var retry = window.setTimeout(function () {
        if (!settled) { settled = true; attempt(); }
      }, 1000);
      window.gtag('get', measurementId, 'session_id', function (sessionId) {
        if (settled) return;
        settled = true;
        window.clearTimeout(retry);
        if (emitted || !analyticsAllowed() || Date.now() >= deadline) return;
        if (!sessionId) { window.setTimeout(attempt, 250); return; }
        emitted = true;
        window.gtag('event', 'rsvp_completed', params);
      });
    }
    attempt();
  };
})();
